import { prepareRuntime } from './appMount';

async function boot() {
  await prepareRuntime('boot');
  await import('./bootloader'); // self-mount side-effect against the dev-root element
}

boot().catch((error) => console.error('[cartbob_ui] boot failed', error));
